import moment from "moment";

export const CARDS_TITLES = {
  LockExtensionAdjustment: "Lock Extensions",
  ReLockFeeAdjustment: "Re-Lock Fees",
  CustomPriceAdjustment: "Custom Price Adjustments",
  CorporatePriceConcession: "Corporate Price Concessions",
  BranchPriceConcession: "Branch Price Concessions",
};

export const CARDS_TEMPLATES = {
  adjustments: {
    description: "",
    price: "",
    persist: true,
  },
  concessions: {
    title: "",
    approvalDate: moment().format("L"),
    price: "",
    approvedBy: "",
    approvedReason: "",
    persist: true,
  },
};

export const CARDS_LIMIT = {
  adjustments: 10,
  concessions: 5,
};

const adjustmentsValidator = {
  fieldName: "adjustments",
  path: "adjustments",
  customValidator: (_, rows = []) => {
    const validation = { hasError: false, messages: [] };

    rows.forEach((row, index) => {
      const rowError = { price: "", description: "" };
      const { price, description } = row;
      const priceValue = parseFloat(price);

      if (Number.isNaN(priceValue)) {
        validation.hasError = true;
        rowError.price = "Required";
      }
      if (priceValue < -9.999 || priceValue > 9.999) {
        validation.hasError = true;
        rowError.price = "Between -9.999 - 9.999";
      }

      if (priceValue === 0) {
        validation.hasError = true;
        rowError.price = "Required";
      }
      if (!(description || "").trim()) {
        validation.hasError = true;
        rowError.description = "Required";
      }
      validation.messages[index] = rowError;
    });

    return validation;
  },
};

const concessionsValidator = {
  fieldName: "concessions",
  path: "concessions",
  customValidator: (_, rows = []) => {
    const validation = { hasError: false, messages: [] };

    rows.forEach((row, index) => {
      const rowError = { price: "", approvalDate: "" };
      const { price, approvalDate } = row;
      const priceValue = parseFloat(price);

      if (Number.isNaN(priceValue)) {
        validation.hasError = true;
        rowError.price = "Required";
      }
      if (priceValue < -9.999 || priceValue > 9.999) {
        validation.hasError = true;
        rowError.price = "Between -9.999 - 9.999";
      }

      if (priceValue === 0) {
        validation.hasError = true;
        rowError.price = "Required";
      }
      if (!(approvalDate || "").trim()) {
        validation.hasError = true;
        rowError.approvalDate = "Required";
      }
      validation.messages[index] = rowError;
    });

    return validation;
  },
};

export const validators = {
  adjustments: adjustmentsValidator,
  concessions: concessionsValidator,
};
